<div style=" height: 100vh; " class="   backdrop-blur-md pt-16  relative " >
  <h1 class="text-[#ff4d06] text-4xl text-center title-font font-medium mb-1"  >{{product!.label!}}</h1>



  <div style="  width: 100%; " class="    w-full ">


    <owl-carousel-o [options]="customOptions" style="height: 100%; width: 100%;">
      @for (slide of getArr(); track slide.img) {
      <ng-template carouselSlide [id]="slide.img">
        <img [src]="slide.img" [alt]="slide.img" [title]="'test'"
          style="width: 100%; max-width: 800px; object-fit: contain; object-position: center;">
      </ng-template>
      }
    </owl-carousel-o>


    <div class="flex flex-row justify-center p-4 absolute top-0 right-0" style="z-index: 99999;">
      <button (click)="close()" aria-label="close window"
        class="  border border-gray-600 justify-center flex  text-white font-semibold  py-2 px-4   hover:border-white hover:text-black hover:bg-[#ff4d067c]  rounded-lg">
     <span>Close </span>  &nbsp; &#10006;
      </button>
    </div>




    <!-- <ngx-slick-carousel *ngIf="false" class="carousel px-4" #slickModal="slick-carousel" style=" "
      [config]="slideConfig">
      @for (slide of getArr(); track slide.img) {
      <div ngxSlickItem class="slide justify-center" style="  ">
        <img src="{{ slide.img }}" alt="Enlarged product image" style="object-fit: contain; object-position: center;   ">

      </div>
      }
    </ngx-slick-carousel> -->

  </div>


</div>